import { render } from "./ShowPatientSmart.vue?vue&type=template&id=1bdb5643&scoped=true"
import script from "./ShowPatientSmart.vue?vue&type=script&lang=js"
export * from "./ShowPatientSmart.vue?vue&type=script&lang=js"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdb5643"]])

export default __exports__